import React, { useContext } from 'react'
import { connect } from 'react-redux'
import InternshipsTableHead from './InternshipsTableHead'
import { InternshipsManagerContext } from '../../../Context/InternshipsManager/InternshipsManagerProvider'
import { getTranslate } from 'react-localize-redux'
import InternshipsTableBody from './InternshipsTableBody'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale)
  }
}

const InternshipsTable = props => {
  const { getDataReady, onTableLeave } = useContext(InternshipsManagerContext)

  return (
    <div className='internship-manager-table'>
      <table className='internships-manager' onMouseLeave={onTableLeave}>
        <InternshipsTableHead />
        <InternshipsTableBody loading={props.loading || !getDataReady.schools || !getDataReady.institutions || !getDataReady.students} />
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(InternshipsTable)
